function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createProductValidator } from "../products/SWBaseProduct";
/** @public */ /** @internal */ export const rootProductVersions = {};
/** @internal */ export const rootProductMigrations = defineMigrations({});
/** @public */ export function isProduct(record) {
    if (!record) return false;
    return record.typeName === "product";
}
/** @public */ export function isProductId(id) {
    if (!id) return false;
    return id.startsWith("product:");
}
export const createProductIdPrefix = (type)=>`product:${type}:`;
export function createProductId({ type, identifier }) {
    return `product:${type}:${identifier}`;
}
/** @internal */ export function createProductRecordType(products) {
    return createRecordType("product", {
        migrations: undefined,
        scope: "session",
        validator: T.model("product", T.union("type", mapObjectMapValues(products, (type, { props, meta })=>createProductValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {}
        }));
}
export function castProductId(id) {
    return {
        toProductDetailId () {
            return id.replace(/^product:/, "product_detail:");
        }
    };
}
export function castProductDetailId(id) {
    return {
        toProductId () {
            return id.replace(/^product_detail:/, "product:");
        }
    };
}
export function castProductDetail(productVariant) {
    return {
        toProduct () {
            const id = castProductDetailId(productVariant.id).toProductId();
            const { rawPrice, rawTrialPeriodPrice, trialPeriodDays, period } = productVariant, rest = _object_without_properties(productVariant, [
                "rawPrice",
                "rawTrialPeriodPrice",
                "trialPeriodDays",
                "period"
            ]);
            return _object_spread_props(_object_spread({}, rest), {
                typeName: "product",
                id
            });
        }
    };
}
export function castProduct(product) {
    return {
        toProductVariant (props) {
            const id = castProductId(product.id).toProductDetailId();
            return _object_spread_props(_object_spread({}, product, props), {
                typeName: "product_detail",
                id
            });
        }
    };
}
